import React from 'react';
import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
// Importation des pages
import Home from '../src/pages/home';
import Service from '../src/pages/service';
import Tarification from '../src/pages/tarification';
import Formation from '../src/pages/formation';
import Contact from '../src/pages/contact';
import Blog from '../src/pages/blog';
import ScrollToTop from "./composants/ScrollToTop";
import ScrollActions from "./composants/ScrollActions";

function App() {
  return (
    <Router>    
      {/* Composant de défilement vers le haut */}
      <ScrollToTop />
      <ScrollActions />
      <Routes>
        {/* Les routes de toutes les pages */}
        <Route path="/" element={<Home />} />

        <Route path="/services" element={<Service />} />
        <Route path="/tarifs" element={<Tarification />} />
        <Route path="/formations" element={<Formation />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
      </Routes>
    </Router>
  );
}

export default App;
